module.exports = __webpack_public_path__ + "img/box-icon1.a59b4880.svg";